var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4973 4.26866L4.25959 11.9295C3.9863 12.2205 3.72183 12.7935 3.66893 13.1902L3.34275 16.0465C3.22815 17.0779 3.96867 17.7832 4.9913 17.6069L7.82996 17.122C8.22667 17.0515 8.78206 16.7606 9.05535 16.4608L16.2931 8.79995C17.5449 7.47759 18.1091 5.9701 16.1608 4.12761C14.2214 2.30275 12.7491 2.9463 11.4973 4.26866Z",
    stroke: "#4E3E91",
    strokeWidth: 1.58683,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2891 5.54688C10.6681 7.98002 12.6429 9.84014 15.0936 10.087",
    stroke: "#4E3E91",
    strokeWidth: 1.58683,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2Icon);
export default __webpack_public_path__ + "static/media/edit-2-icon.e0bfaca9980f53324d2f0c315bccea3b.svg";
export { ForwardRef as ReactComponent };